export default __webpack_public_path__ + "static/media/print.3331f201.svg";